import ClientOAuth2 from 'client-oauth2';

import * as actionTypes from '../../constants/actionTypes';
import { ThunkDispatch } from '../../meta/types/actions';
import { CONFIG } from '../../meta/types/config';
import { Claims, SentinelUser } from '../../meta/types/user';
import OAuthResource from '../../services/Identity/OAuthResource';
import { getSkin } from '../../lib/skin';

const { clientId, redirectUri } = getSkin().getAuthParameters();
const oauth = new ClientOAuth2({
  clientId,
  accessTokenUri: `${CONFIG.identityServiceBasePath}/oauth/token`,
  authorizationUri: `${CONFIG.identityServiceBasePath}/oauth/auth`,
  redirectUri: `${redirectUri}/oauthCallback.html`,
});

export interface ILogout {
  type: actionTypes.LOGOUT;
}

export const localLogout = (): ILogout => ({
  type: actionTypes.LOGOUT,
});

export const logout = () => {
  return (dispatch: ThunkDispatch): Promise<ILogout> => {
    return OAuthResource.logout()
      .then(() => dispatch(localLogout()))
      .catch(() => dispatch(localLogout()));
  };
};

export interface ISetConfigurableUser {
  type: actionTypes.SET_CONFIGURABLE_USER;
  user: SentinelUser;
}

export const setConfigurableUser = (user: SentinelUser): ISetConfigurableUser => ({
  type: actionTypes.SET_CONFIGURABLE_USER,
  user,
});

export interface ISetTokenChecked {
  type: actionTypes.SET_TOKEN_CHECKED;
  tokenChecked: boolean;
}

export const setTokenChecked = (tokenChecked: boolean): ISetTokenChecked => ({
  type: actionTypes.SET_TOKEN_CHECKED,
  tokenChecked,
});

export interface ISetLoggedIn {
  type: actionTypes.SET_LOGGED_IN;
  user: SentinelUser;
  impersonatorClaims?: Claims;
  rootManaging: boolean;
}

export const setLoggedIn = (
  user: SentinelUser,
  impersonatorClaims: Claims | undefined,
  rootManaging: boolean,
): ISetLoggedIn => ({
  type: actionTypes.SET_LOGGED_IN,
  user,
  impersonatorClaims,
  rootManaging,
});

export const redirectToLogin = (state: string) => {
  window.location.assign(oauth.token.getUri({ state: encodeURIComponent(state) }));
};
